<template>
  <div class="flex flex-col gap-1">
    <span class="text-xs font-bold" :class="variant === 'add' ? 'text-success-700' : 'text-error-700'">
      {{ title }}
    </span>
    <div class="flex flex-wrap gap-1">
      <!--
        Permissions are shown in the `domain.permission-id` form, because that is how they are written
        in the export file and everywhere else in the platform.
      -->
      <span
        v-for="permission in visiblePermissions"
        :key="toQualifiedPermissionId(permission)"
        class="rounded px-1.5 py-0.5 font-mono text-xs"
        :class="variant === 'add' ? 'bg-success-50 text-success-700' : 'bg-error-50 text-error-700'"
      >
        {{ toQualifiedPermissionId(permission) }}
      </span>

      <button
        v-if="hasMore"
        type="button"
        class="text-xs text-secondary-500 underline"
        @click="expanded = !expanded"
        data-testid="permission-ref-list-toggle"
      >
        {{ expanded ? t('iam.roles.import.showLess') : t('iam.roles.import.showAll', { count: permissions.length }) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PermissionRef, toQualifiedPermissionId } from '@infuse/iam/role/type';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const COLLAPSED_LIMIT = 12;

const { t } = useI18n();

const props = defineProps<{
  title: string;
  permissions: PermissionRef[];
  variant: 'add' | 'remove';
}>();

const expanded = ref(false);

// A role can carry hundreds of permissions; showing them all by default would bury everything else.
const hasMore = computed(() => props.permissions.length > COLLAPSED_LIMIT);
const visiblePermissions = computed(() =>
  expanded.value || !hasMore.value ? props.permissions : props.permissions.slice(0, COLLAPSED_LIMIT)
);
</script>
